import { zonesAtPoint } from './zoneClick.js';

const SOURCE_ID = 'areas';
const FILL_ID = 'areas-fill';
const OUTLINE_ID = 'areas-outline';

let drawnKey = '';
let areasForClick = [];
let pointerHandlers = null;

function closeRing(area) {
  const coordsList = area?.coordList?.[0]?.Coord || [];
  if (coordsList.length < 3) return null;

  const ring = [];
  for (let i = 0; i < coordsList.length; i++) {
    const lon = Number(coordsList[i]?.Lon?.[0]);
    const lat = Number(coordsList[i]?.Lat?.[0]);
    if (!Number.isFinite(lon) || !Number.isFinite(lat)) return null;
    ring.push([lon, lat]);
  }

  const first = ring[0];
  const last = ring[ring.length - 1];
  if (first[0] !== last[0] || first[1] !== last[1]) {
    ring.push([first[0], first[1]]);
  }

  return ring.length >= 4 ? ring : null;
}

export function areasToFeatureCollection(areaMessages) {
  const list = Array.isArray(areaMessages) ? areaMessages : [];
  const features = [];
  const areas = [];

  for (let i = 0; i < list.length; i++) {
    const ring = closeRing(list[i]);
    if (!ring) continue;
    const color = list[i].sColor?.[0] || '#ffff';
    features.push({
          type: 'Feature',
      properties: {
        color,
        areaIndex: areas.length,
      },
          geometry: {
            type: 'Polygon',
        coordinates: [ring],
        },
      });
    areas.push(list[i]);
  }

  return {
    type: 'FeatureCollection',
    features,
    areas,
  };
}

function collectionKey(collection) {
  let key = '';
  const features = collection.features;
  for (let i = 0; i < features.length; i++) {
    key += features[i].properties.color;
    key += features[i].geometry.coordinates[0].join(',');
    key += ';';
  }
  return key;
}

// Areas stay on the map across redraws. clearMap does not track these layers,
// so a flight-data refresh does not blink them off.
export function addAreas(map, areaMessages, handleOpenModal) {
  if (!map.current) return;

  const collection = areasToFeatureCollection(areaMessages);
  areasForClick = collection.areas;
  const key = collectionKey(collection);
  if (key === drawnKey && map.current.getLayer(FILL_ID)) return;
  drawnKey = key;

  const data = {
    type: 'FeatureCollection',
    features: collection.features,
  };

  if (map.current.getSource(SOURCE_ID)) {
    map.current.getSource(SOURCE_ID).setData(data);
  } else if (data.features.length) {
    map.current.addSource(SOURCE_ID, {
      type: 'geojson',
      data,
    });
  } else {
    return;
    }

  if (!map.current.getLayer(FILL_ID)) {
      map.current.addLayer({
      id: FILL_ID,
        type: 'fill',
      source: SOURCE_ID,
        layout: {},
        paint: {
        'fill-color': ['get', 'color'],
          'fill-opacity': 0.5,
        },
      });
    }

  if (!map.current.getLayer(OUTLINE_ID)) {
      map.current.addLayer({
      id: OUTLINE_ID,
        type: 'line',
      source: SOURCE_ID,
        layout: {},
        paint: {
        'line-color': ['get', 'color'],
          'line-width': 2,
        },
      });

    }

  unbindPointer(map);
  bindPointer(map, handleOpenModal);
}

export function areaAtIndex(index) {
  return areasForClick[index];
}

function unbindPointer(map) {
  if (!pointerHandlers || !map.current) return;

  for (let i = 0; i < pointerHandlers.layers.length; i++) {
    const layerId = pointerHandlers.layers[i];
    map.current.off('click', layerId, pointerHandlers.click);
    map.current.off('mouseenter', layerId, pointerHandlers.enter);
    map.current.off('mouseleave', layerId, pointerHandlers.leave);
  }
  pointerHandlers = null;
}

function bindPointer(map, handleOpenModal) {
  const click = (event) => {
    const items = zonesAtPoint(map.current, event.point, areaAtIndex);
    if (!items.length) return;
    handleOpenModal({ items });
  };
  const enter = () => {
      map.current.getCanvas().style.cursor = 'pointer';
      };
  const leave = () => {
      map.current.getCanvas().style.cursor = '';
      };
  const layers = [FILL_ID, OUTLINE_ID];

  for (let i = 0; i < layers.length; i++) {
    map.current.on('click', layers[i], click);
    map.current.on('mouseenter', layers[i], enter);
    map.current.on('mouseleave', layers[i], leave);
    }
  pointerHandlers = { click, enter, leave, layers };
}
